import styled from "styled-components";
import { Colors, FontSize } from "../../globalStyles";
import { AnimationOnScroll } from "react-animation-on-scroll";

export const CardWrapper = styled(AnimationOnScroll)`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(24, 38, 65, 0.08);
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(24, 38, 65, 0.08);
  padding: 2.25rem 1.75rem 2rem;
  flex: 1 1 0;
  max-width: 21.5rem;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 36px rgba(24, 38, 65, 0.14);
  }
  @media screen and (max-width: 960px) {
    flex: none;
    width: 100%;
    max-width: 22rem;
    padding: 2rem 1.5rem 1.75rem;
  }
`;

export const CardImg = styled.img`
  height: 120px;
  width: auto;
  max-width: 100%;
  margin-bottom: 1.5rem;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardTitle = styled.h3`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.8rem;
  min-height: 3.6rem;
  display: flex;
  align-items: center;
  color: ${Colors.primary.blue};
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.03em;
  margin-bottom: 0.75rem;
  @media screen and (max-width: 960px) {
    font-size: ${FontSize.mobile.cardTitle};
    line-height: 1.6rem;
    min-height: 0;
  }
`;

export const CardText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: ${FontSize.desktop.paragraph};
  line-height: 1.65;
  text-align: center;
  color: ${Colors.neutral.veryDarkGray};
  @media screen and (max-width: 960px) {
    font-size: ${FontSize.mobile.paragraph};
  }
`;
